export const gitVersion = {
  commit: '0b11ccc',
  commitLong: '0b11cccaa28d76a05ad496526a9093417a24a589',
  branch: 'Detached: 0b11cccaa28d76a05ad496526a9093417a24a589'
}